export default __webpack_public_path__ + "static/bgm-8ee0d170ba262cd378e13cd873784b3b.mp3";